import cn from "classnames";
import React from 'react';
import "./style.css";

const TaskStatus = ({
  status
}) => (
    <div className={cn("task-status", status)}>
      {status}
    </div>
  );

export default TaskStatus;



// WEBPACK FOOTER //
// ./src/components/TaskListItem/TaskStatus/index.js